import { render, staticRenderFns } from "./DiscardProduct.vue?vue&type=template&id=f870fa28"
import script from "./DiscardProduct.vue?vue&type=script&lang=ts"
export * from "./DiscardProduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports